import { ArrowDown } from "lucide-react";

export const scrollToOffer = (e) => {
  e?.preventDefault();
  const el = document.getElementById("vita");
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -40, duration: 1.8 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const CtaButton = ({ testId, label = "Plano Vitalício", light = false }) => (
  <a
    href="#vita"
    onClick={scrollToOffer}
    data-testid={testId}
    className={`group inline-flex items-center gap-3 rounded-full px-8 py-4 text-sm font-semibold tracking-[0.14em] uppercase transition-[transform,background-color,box-shadow] duration-500 hover:-translate-y-0.5 ${
      light
        ? "bg-[var(--forest)] text-[var(--cream)] hover:shadow-[0_18px_40px_-18px_rgba(15,31,23,0.7)]"
        : "bg-[var(--cream)] text-[var(--forest)] hover:shadow-[0_18px_40px_-14px_rgba(217,180,90,0.55)]"
    }`}
  >
    {label}
    <span className="grid h-7 w-7 place-items-center rounded-full bg-[var(--gold)] text-[var(--forest)] transition-transform duration-500 group-hover:translate-y-0.5">
      <ArrowDown size={14} strokeWidth={2.2} />
    </span>
  </a>
);
